import {
    useClient, cache, dedup,
} from 'villus';
import { useRoute } from 'vue-router';
import { batch } from '@villus/batch';

export const getClient = () => {
    const route = useRoute();

    // Fix preview in Craft they add query parameters dynamically and it doesn't trigger re-rendering automatically
    const computedURLPlugin = ({ opContext }) => {
        if (route.query.token && route.query['x-craft-live-preview']) {
            opContext.url = `/api/?x-craft-live-preview=${route.query['x-craft-live-preview']}&token=${route.query.token}`;
        } else {
            opContext.url = '/api/';
        }
    };
    const craftURL = route.query.token && route.query['x-craft-live-preview']
        ? `/api/?x-craft-live-preview=${route.query['x-craft-live-preview']}&token=${route.query.token}`
        : '/api/';
    return useClient({
        url: craftURL,
        use: [computedURLPlugin, batch({ timeout: 5 }), cache(), dedup()],
    });
};
